import api from './api';

/**
 * @param {string} tokenId
 * @param {boolean} [useChinaUrl]
 * @returns {Promise<{
 *  token_id: string
 *  status: 'NOT_REDEEMED' | 'REDEEMED' | 'DISABLED'
 *  date_of_start: null
 *  date_of_end: null
 *  description: string
 *  created_at: string
 *  user_id: null
 *  candidate_bp_no:string
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tokens-getToken
 */
export default async function getToken(level_id, tokenId, useChinaUrl = false) {
    const { data } = await api.get(`levels/${level_id}/tokens/${tokenId}`, { useChinaUrl });

    return data;
}